{
  "queryName": "leastRecentlyUpdated",
  "queryParam": null,
  "fields": ["id", "name", "updatedAt"]
}
